import React from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import { Title } from "../../components/NewTitle";
import { HomeInfo } from "../../blocks/home-info";
import { NoticeWrap } from "../../components/NoticeWrap";

export const HomeAPI = ({ dataRows, vueLink } = {}) => {
  const { t } = useTranslation();

  const defaultDataRows = [
    {
      count: "548%",
      text: "ROI",
    },
    {
      count: "+23%",
      text: t("home.api.roi.userRate"),
    },
    {
      count: "-90%",
      text: t("home.api.roi.maintenanceCost"),
    },
    {
      count: "-50%",
      text: t("home.api.roi.developmentTime"),
    },
  ];

  return (
    <div className="home-api">
      <div className="inner">
        {/* <HomeInfo /> */}
        <div className="home-api-title">
          <div className="home-api-title-dot">
            {t("home.api.title-dot-one")}
          </div>
          <NoticeWrap
            noticeList={[
              t("home.api.title-dot-one-first"),
              t("home.api.title-dot-one-second"),
              t("home.api.title-dot-one-third"),
              t("home.api.title-dot-one-first"),
            ]}
          />
          <div className="home-api-title-dot">
            {t("home.api.title-dot-two")}
          </div>
          <NoticeWrap
            noticeList={[
              t("home.api.title-dot-two-first"),
              t("home.api.title-dot-two-second"),
              t("home.api.title-dot-two-third"),
              t("home.api.title-dot-two-first"),
            ]}
          />
          <div className="home-api-title-dot">
            {t("home.api.title-dot-three")}
          </div>
          <NoticeWrap
            noticeList={[
              t("home.api.title-dot-three-first"),
              t("home.api.title-dot-three-second"),
              t("home.api.title-dot-three-third"),
              t("home.api.title-dot-three-first"),
            ]}
          />
        </div>

        <div className="home-api-card-warp">
          <div className="home-api-card">
            {(dataRows || defaultDataRows).map((item, index) => {
              return (
                <div className="home-api-card-item" key={item.text}>
                  <span className={index === 0 ? "first-count" : "count"}>
                    {item.count}
                  </span>
                  <span className={index === 0 ? "first-text" : "text"}>
                    {item.text}
                  </span>
                </div>
              );
            })}

            <div className="dataFrom">
              {t("home.api.roi.dataFrom")}
              <i
                className="icon authing-icon authing-registered-line"
                style={{ marginLeft: 2 }}
              ></i>
            </div>
          </div>
          <div className="home-api-card-defaul-warp">
            <a
              className="home-api-card-default"
              href={vueLink ? vueLink : "//docs.authing.cn/"}
              target="_blank"
              rel="noopener noreferrer"
              data-log="info/doc"
            >
              <div className="home-api-card-label-doc">
                {t("home.api.doc.type")}
              </div>
              <div className="home-api-card-title">
                {t("home.api.doc.title")}
                <i className="icon authing-icon authing-arrow-down-line arrow"></i>
              </div>
              <div className="home-api-card-descript">
                {t("home.api.doc.descript")}
              </div>
            </a>
            <a
              className="home-api-card-default"
              style={{
                backgroundImage:
                  "url(//files.authing.co/authing-website/home-api-bg-img-community.png)",
              }}
              href="https://forum.authing.cn/"
              target="_blank"
              rel="noopener noreferrer"
              data-log="info/community"
            >
              <div className="home-api-card-label-community">
                {t("home.api.community.type")}
              </div>
              <div className="home-api-card-title">
                {t("home.api.community.title")}
                <i className="icon authing-icon authing-arrow-down-line arrow"></i>
              </div>
              <div className="home-api-card-descript">
                {t("home.api.community.descript")}
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
